import styled from "styled-components";
import React, { useState } from "react";
import { PodSettings } from "../../assets/Podcast/PodSettings";
import { gql, useMutation, useQuery } from "@apollo/client";
import { Loading } from "../../components/Loading";
import { Edit } from "../../assets/Menu/Edit";
import { Dialog } from "@material-ui/core";
import { TextBtn } from "../../components/inputs/TextBtn";
import { SelectInputWTitle } from "../../components/inputs/SelectInputWTitle";
import { TextInputWTitle } from "../../components/inputs/TextInputWTitle";
import { DashAdd } from "../../assets/Menu/DashAdd";
import { IconEraser } from "../../assets/IconEraser";
import { PodCards } from "../../assets/Podcast/PodCards";

const StyleCss = styled.div`
  .content {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    padding: 1rem 1.5rem 1rem 1.5rem;
    .card {
      width: calc(50% - 2.5rem - 2px);
      padding: 1rem;
      border: 1px solid var(--n-grey-10);
      border-radius: calc(var(--border-radius) / 2);
      display: flex;
      flex-direction: column;
      gap: 1rem;
      &.green {
        background-color: var(--error-bg);
      }
      &.yellow {
        background-color: var(--error-bg-yellow);
      }
      &.red {
        background-color: var(--error-bg-red);
      }
      .info {
        display: flex;
        justify-content: space-between;
      }
      .actions {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
        align-items: center;
        .expand {
          flex-grow: 1;
        }
      }
      .action {
        padding: 8px;
        border: 1px solid var(--n-grey-3);
        background-color: var(--n-grey-1);
        border-radius: 4px;
        .edit {
          display: block;
          fill: var(--n-grey-7);
          width: 18px;
          height: 18px;
        }
        .erase {
          display: block;
          stroke: var(--n-grey-7);
          width: 18px;
          height: 18px;
        }
      }
    }
  }
`;
const StyleDialogCss = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  gap: 0.5rem;
  .title {
    margin: 0 1rem;
    font-size: 20px;
    font-weight: 500;
    padding: 1rem 0.5rem 0.5rem;
    border-bottom: 1px solid var(--n-text-4);
  }
  .body {
    display: flex;
    flex-direction: column;
    margin: 0 1rem;
    .filled {
      display: flex;
      justify-content: space-between;
      gap: 1rem;
    }
    .input {
      margin-top: 1rem;
    }
    .show-value {
      padding: 0 0.5rem;
    }
  }
  .action {
    display: flex;
    justify-content: flex-end;
    margin: 0 1rem;
    gap: 1rem;
    padding: 0.5rem 0;
    border-top: 1px solid var(--n-text-4);
  }
`
export const BAccounts_Query = gql`
  query BAccountsQuery{
    getBankAccounts{
      _id
      User
      CardNumber
      aban
      name
      bank
      status
      description
    }
  }
`
const AddOrEditBankAccount_Mutation = gql`
  mutation AddOrEditBankAccount(
    $_id: ID, 
    $CardNumber: String!, 
    $aban: String!, 
    $name: String!, 
    $bank: String!,
  ){
    addOrEditBankAccount(
      _id: $_id
      CardNumber: $CardNumber
      aban: $aban
      name: $name
      bank: $bank
    ){
        status
    }
  }
`
const DeleteBankAccount_Mutation = gql`
  mutation DeleteBankAccount(
    $_id: ID!
  ){
    deleteBankAccount(
      _id: $_id
    ){
        status
    }
  }
`
function WorkPageAccounts(props) {
  const [openform, setOpenform] = useState(false);
  const initForm = {
    CardNumber: "",
    aban: "",
    name: "",
    bank: "-1",
  }
  const [formdata, setFormdata] = useState(initForm);

  const accounts = useQuery(BAccounts_Query, {
    fetchPolicy: "network-only"
  });
  const [CDataQuery, { loading }] = useMutation(
    AddOrEditBankAccount_Mutation,
    {
      onCompleted: proccessData,
    }
  );
  const [DDataQuery] = useMutation(
    DeleteBankAccount_Mutation,
    {
      onCompleted: proccessDataDelte,
    }
  );
  function proccessData(newData) {
    if (newData.addOrEditBankAccount.status) {
      setOpenform(false)
      setFormdata(initForm)
      props.updateError({
          text: 'Saved successfully',
          time: 3,
          type: 'confirm'
      });
      accounts.refetch()
    }
  }
  function proccessDataDelte(newData) {
    if (newData.deleteBankAccount.status) {
      props.updateError({
          text: 'Deleted successfully',
          time: 3,
          type: 'error'
      });
      accounts.refetch()
    }
  }
  function sendData() {
    CDataQuery({
      variables: {
        ...formdata,
      },
    });
  }
  const checkData = () => {
      if (
        formdata.aban &&
        formdata.CardNumber.length === 16
      ) {
        return true;
      } else {
        return false;
      }
  };
  onchange = (e) => {
    let value = e.target.value;
    let temp = {...formdata};
    switch (e.target.name) {
      case "bank":
        temp.bank= value
        break;
      case "name":
        temp.name= value
        break;
      case "CardNumber":
        temp.CardNumber= value
        break;
      case "aban":
        temp.aban= value
        break;
      default:
        break;
    }
    setFormdata(temp)
  };
  const openFormFunc = () => {
    setOpenform(true)
    setFormdata(initForm)
  }
  const openFormFuncEdit = (data) => {
    setOpenform(true)
    setFormdata(data)
  }
  const deleteOne = (data) => {
    let confirm = window.confirm("are you sure?")
    if(confirm){
      DDataQuery({
        variables: {
          _id: data._id,
        },
      });
    }
  }
  if(accounts.loading){
    return (
      <StyleCss className="main-box">
        <div className="title-bar">
          <div className="title">
            <div className="icon"><PodCards/></div>
            <div className="text">Bank Accounts</div>
          </div>
          <div 
            className="action" 
            onClick={openFormFunc}
          >
            <DashAdd/>
          </div>
        </div>
        <div className="content">
          <Loading/>
        </div>
      </StyleCss>
    )
  }
  const makeStatus = (e, d) => {
    switch(e){
      case 1:
          return "newly added"
      case 2:
          return "Account confirmed"
      case -1:
          return d
      default:
          return ""
    }
  }
  const makeStatusColor = (e) => {
    switch(e){
      case 1:
          return "yellow"
      case 2:
          return "green"
      case -1:
          return "red"
      default:
          return ""
    }
  }
  const makeCards = () => {
    if(!accounts.data.getBankAccounts){
      return "";
    }
    return accounts.data.getBankAccounts.map((v, i) => {
      let cardnumber = v.CardNumber.toString();
      let newCard = v.CardNumber
      if(cardnumber.length === 16){
        cardnumber = cardnumber.split("");
        newCard = ""
        for (let i = 0; i < 4; i++) {
          if(i !== 0){
            newCard = newCard + " - "
          }
          newCard = newCard + [...cardnumber.splice(0, 4)].join("");

        }
      }
      return (
        <div className={"card" + " " + makeStatusColor(v.status)} key={i}>
          <div className="actions">
            <div className="status">
              {makeStatus(v.status, v.description)}
            </div>
            <div className="expand"></div>
            <div 
              className="action" 
              onClick={() => openFormFuncEdit(v)}
            >
              <Edit className={"edit"}/>
            </div>
            <div 
              className="action" 
              onClick={() => deleteOne(v)}
            >
              <IconEraser className={"erase"}/>
            </div>
          </div>
          <div className="aban">aban: {v.aban}</div>
          <div className="cardnumber">{newCard}</div>
          <div className="info">
            <div className="name">{v.name}</div>
            <div className="bank">{v.bank}</div>
          </div>
        </div>
      )
    })
  }
  return (
    <>
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
            <div className="icon"><PodCards/></div>
            <div className="text">Bank Accounts</div>
          </div>
          <div 
            className="action" 
            onClick={openFormFunc}
          >
            <DashAdd/>
          </div>
      </div>
      <div className="content">
        {makeCards()}
      </div>
    </StyleCss>
    <Dialog
        open={openform}
        onClose={() => {
          setOpenform(false)
        }}
        PaperProps={{
          style: {
            borderRadius: "8px"
          }
        }}
        fullWidth={true}
      >
      <StyleDialogCss>
        <div className="title">
          Bank Account
        </div>
        <div className="body">
          <div className="filled">
            <TextInputWTitle
              style={{
                minWidth: "40%"
              }} 
              name={"name"}
              value={formdata.name}
              error={""}
              onchange={onchange}
              title="Owner"
            />
            <SelectInputWTitle
              style={{
                minWidth: "40%"
              }} 
              title={'Bank'} 
              name={'bank'} 
              value={formdata.bank}
              options={[
                {
                  value: "-1",
                  name: "Select One",
                },
                {
                  value: "Mellat",
                  name: "Mellat",
                },{
                  value: "Meli",
                  name: "Meli",
                }
              ]} 
              error={''} 
              onchange={onchange}
            />
          </div>
          <div className="input">
            <TextInputWTitle
              style={{
                minWidth: "40%"
              }} 
              name={"CardNumber"}
              value={formdata.CardNumber}
              error={""}
              onchange={onchange}
              title="Card Number"
            />
          </div>
          <div className="input">
            <TextInputWTitle
              style={{
                minWidth: "40%"
              }} 
              name={"aban"}
              value={formdata.aban}
              error={""}
              onchange={onchange}
              title="aban Code (shaba)"
            />
          </div>
        </div>
        <div className="action">
          <TextBtn
            onclick={() => {
              setOpenform(false)
            }}
            style={{
              width: "30%"
            }}
            text={"Cancel"}
            type={""}
            newType1={true}
          />
          <TextBtn
            onclick={() => {
              sendData()
            }}
            style={{
              width: "40%"
            }}
            text={"Save"}
            type={""}
            loading={loading}
            disabled={!checkData() || loading}
          />
        </div>
      </StyleDialogCss>
    </Dialog>
    </>
  )
}
export default WorkPageAccounts;